import { themeLss } from "../../lss";
import styled from "../../styled";
export var FormWrapper = styled.form(themeLss());
//# sourceMappingURL=FormWrapper.js.map